module.exports = __webpack_public_path__ + "img/ss-savanah.4aa66cc9.png";